const buildItemsDepthMap = (items) => {
  const orderToIdMap = new Map();
  const idToDepthMap = new Map();
  items.forEach((item) => {
    orderToIdMap.set(item.order, item.id);
    idToDepthMap.set(item.id, { depth: 1, maxChildDepth: 0 });
  });

  items.forEach((item) => {
    const parts = item.order.split('.');
    const depth = parts.length;

    if (depth === 1) return;

    const orderParts = item.order.split('.').map(Number);
    const parentOrder =
      orderParts.length > 1 ? item.order.substring(0, item.order.lastIndexOf('.')) : null;

    if (parentOrder && !orderToIdMap.has(parentOrder)) {
      throw new Error(
        `Invalid tree structure: item with order "${item.order}" (id: ${item.id}) ` +
          `references non-existent parent order "${parentOrder}"`
      );
    }

    const itemEntry = idToDepthMap.get(item.id);

    if (!itemEntry) return;

    itemEntry.depth = depth;

    let currentOrder = parts[0];
    const lastAncestorIndex = depth - 1;

    parts.forEach((_, index) => {
      if (index === lastAncestorIndex) return;

      const ancestorId = orderToIdMap.get(currentOrder);

      if (ancestorId !== undefined) {
        const ancestorEntry = idToDepthMap.get(ancestorId);

        if (ancestorEntry) {
          const maxChildDepth = depth - index - 1;

          if (maxChildDepth > ancestorEntry.maxChildDepth) {
            ancestorEntry.maxChildDepth = maxChildDepth;
          }
        }
      }

      if (index + 1 < lastAncestorIndex) {
        currentOrder += `.${parts[index + 1]}`;
      }
    });
  });

  return idToDepthMap;
};

export default buildItemsDepthMap;
